/* eslint-disable class-methods-use-this */
import { track } from "jiffy-analytics";
import EventClass from "common/utils/ui/event-class";
import "./digital-assets-list-pagination.scss";

export class DigitalAssetsListPagination extends EventClass {
  get #trackData() {
    const $pagination = document.querySelector(".js-digital-assets-list-pagination");
    const { totalPages, resultCount, pageName } = $pagination.dataset;

    return {
      total_pages: totalPages,
      result_count: resultCount,
      page_name: pageName
    };
  }

  #trackDirection(pageNumber) {
    let direction = {};

    if (pageNumber === "Next ›") {
      direction = { direction: "next" };
    } else if (pageNumber === "‹ Prev") {
      direction = { direction: "prev" };
    }

    return direction;
  }

  event(_, $target) {
    track("digital_asset_pagination_clicked", {
      page_number: $target.textContent,
      ...this.#trackData,
      ...this.#trackDirection($target.textContent)
    });
  }
}

export default () =>
  new DigitalAssetsListPagination({
    eventSelector: ".js-digital-assets-list-pagination .jiffy-pagination__number"
  });
